/** Kannada: the worker's record, in Passbook and on their card. */
export const record = {
    "record.title": "ಮಾಡಿದ ಕೆಲಸಗಳು",
    "record.jobs.one": "{count} ಕೆಲಸ ಮಾಡಿದ್ದೀರಿ",
    "record.jobs.other": "{count} ಕೆಲಸಗಳನ್ನು ಮಾಡಿದ್ದೀರಿ",
    "record.households.one": "{count} ಮನೆ",
    "record.households.other": "{count} ಮನೆಗಳು",
    "record.since": "{month}ನಿಂದ",
    "record.state_received": "{price} ಬಂದಿದೆ",
    "record.state_cash": "{price} ನಗದು ಬಂದಿದೆ",
    "record.state_waiting": "ಹಣಕ್ಕಾಗಿ ಕಾಯುತ್ತಿದೆ",
    "record.state_not_asked": "ಇನ್ನೂ ಕೇಳಿಲ್ಲ",
    "record.state_cancelled": "ರದ್ದಾಗಿದೆ",
    "record.open": "ಈ ಕೆಲಸ ನೋಡಿ",
    "record.close": "ಈ ಕೆಲಸ ಮರೆಮಾಡಿ",
    // On the worker's card, for households to see (ADR 0036)
    "record.card_label": "ಕೆಲಸದ ದಾಖಲೆ",
    "record.card_jobs": "ಮುಗಿಸಿದ ಕೆಲಸಗಳು",
    "record.card_rated.one": "{count} ರೇಟಿಂಗ್",
    "record.card_rated.other": "{count} ರೇಟಿಂಗ್‌ಗಳು",
    "record.card_not_rated": "ಇನ್ನೂ ರೇಟಿಂಗ್ ಇಲ್ಲ",
    "record.card_stars": "★ {stars}",
    "record.card_no_stars": "–",
    "record.card_hidden": "ಈ ಸಂಖ್ಯೆಗಳು ಮನೆಯವರಿಗೆ ಕಾಣುವುದಿಲ್ಲ. ಗೌಪ್ಯತೆಯಲ್ಲಿ ಅವುಗಳನ್ನು ತೋರಿಸಬಹುದು.",
    "record.setting": "ನನ್ನ ಕಾರ್ಡ್‌ನಲ್ಲಿ ನನ್ನ ದಾಖಲೆ ತೋರಿಸಿ",
    "record.setting_about": "ಮುಗಿಸಿದ ಕೆಲಸಗಳು ಮತ್ತು ಮನೆಯವರ ರೇಟಿಂಗ್, ಮನೆಯವರು ನಿಮ್ಮ ಕಾರ್ಡ್‌ನಲ್ಲಿ ನೋಡಲು. ಎಲ್ಲವೂ ಅಥವಾ ಏನೂ ಇಲ್ಲ: ಒಂದು ರೇಟಿಂಗ್ ಅನ್ನು ಮರೆಮಾಡಲು ಆಗುವುದಿಲ್ಲ.",
};
//# sourceMappingURL=record.js.map